/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */

// import Dashboard from "@/views/dashboard/Dashboard";
// import BaseCustomer from "@/views/dashboard/BaseCustomer";
import Firing from "@/views/firing/Firing";
import QjListTemplateWhatsApp from "@/views/QjListTemplateWhatsApp";
import StrategyProduction from "@/views/strategy/StrategyProduction";
import StrategyPlanning from "@/views/strategy/StrategyPlanning";
import StrategyArchived from "@/views/strategy/StrategyArchived";
import ApproachTable from "@/views/approach/ApproachTable";
import ApproachForm from "@/views/approach/ApproachForm";
import NotificationHistoryTable from "@/views/notification/NotificationHistoryTable";
import NotificationTable from "@/views/notification/NotificationTable";
import ReportingHistory from "@/views/reporting/ReportingHistory";
import DashboardNotifications from "@/views/dashboard/DashboardNotifications";
// import BaseCustomer from "@/views/dashborad/BaseCustomer";
import AdministrationForecast from "@/views/administration/AdministrationForecast";
import AdministrationPotential from "@/views/administration/AdministrationPotential";
import AdministrationEvent from "@/views/administration/AdministrationEvent";
import Stimulus from "@/views/consolidation/Stimulus";
import StimulusHistory from "@/views/consolidation/stimulusHistory/index";
import PreparesDaily from "@/views/consolidation/PreparesDaily";
import CreditorsInfo from "@/views/consolidation/creditorsInfo/CreditorsInfo";
import CreditorsManager from "@/views/consolidation/creditorsManager/CreditorsManager";
import ViewTree from "@/views/consolidation/ViewTree";
import ApproachFlow from "@/views/consolidation/ApproachFlow";
import ApproachFlowForm from "@/views/consolidation/ApproachFlowForm";
import Pools from "@/views/pools/Pools";
import InitiativeManager from "@/views/initiativeManager/index";
import SenderManager from "@/views/senderManager/index";
import IncentiveApproach from "@/views/incentiveApproach/index";
import IncentiveApproachForm from "@/views/incentiveApproach/IncentiveApproachForm";
import IncentiveFirings from "@/views/incentiveFirings/index";

// import Offset from "@/components/helper/Offset";
import Error from "@/components/helper/Error";
import NotFound from "@/components/helper/NotFound";
import { AUTH, CHECK_AUTH } from "@/store/actions.type";
import store from "@/store";

const auth = (to, from, next) => {

    store.dispatch(AUTH, to.query.token).then(() => {
        next('/dashboard')
    })
}

const checkAuth = (to, from, next) => {
    store.dispatch(CHECK_AUTH).then((isAuthenticated) => {

        if (isAuthenticated) {
            next()
        } else {
            next({ path: '/authenticate', query: { redirect: to.fullPath } })
        }
    }).catch(() => {
        next('/error')
    })
}

export default [{
    path: '/authenticate',
    name: 'authenticate',
    beforeEnter: auth
},
{
    path: "",
    redirect: "/dashboard",
    props: true,
},
{
    path: "/dashboard",
    component: DashboardNotifications,
    beforeEnter: checkAuth,
    name: "Dashboard",
},
{
    path: "/dashboard-old",
    component: DashboardNotifications,
    beforeEnter: checkAuth,
    name: "DashboardOld",
},
{
    path: "/firing/:firing_id",
    name: "Disparo",
    component: Firing,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/strategies/production",
    name: "Sob demanda",
    component: StrategyProduction,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/strategies/planning",
    name: "Planejamento",
    component: StrategyPlanning,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/strategies/archived",
    name: "Arquivados",
    component: StrategyArchived,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/incentive-approach",
    name: "Abordagens de Incentivo",
    component: IncentiveApproach,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/incentive-firings",
    name: "Disparos de Incentivos",
    component: IncentiveFirings,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/incentive-approach/:incentive_approach_id",
    name: "Abordagens de Incentivo",
    component: IncentiveApproachForm,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: '/whatsapp',
    component: QjListTemplateWhatsApp,
    beforeEnter: checkAuth,
    name: 'Modelos do WhatsApp',
    props: true,
},
{
    path: "/approaches",
    name: "Abordagens",
    component: ApproachTable,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/approaches/:approach_id",
    name: "Abordagem",
    component: ApproachForm,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/notifications",
    name: "Disparos",
    component: NotificationTable,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/notifications-history",
    name: "Histórico de disparos",
    component: NotificationHistoryTable,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/reporting-history",
    name: "Histórico de relatórios",

    component: ReportingHistory,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/administration-forecast",
    name: "Previsão mensal por credor",
    component: AdministrationForecast,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/administration-event",
    name: "Gestão dos eventos",
    component: AdministrationEvent,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/administration-potential",
    name: "Gestão dos potenciais",
    component: AdministrationPotential,
    beforeEnter: checkAuth,

    props: true,
},
{
    path: "/creditors-info",
    name: "Informações Dos Credores",
    component: CreditorsInfo,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/creditors-manager/:creditor_id?",
    name: "Gerenciador de Credores",
    component: CreditorsManager,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/debt-tree/stimulus",
    name: "Estímulos",
    component: Stimulus,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/debt-tree/stimulus-history",
    name: "Histórico de estímulos",
    component: StimulusHistory,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/debt-tree/prepares-daily",
    name: "Previsão dos preparos do dia",
    component: PreparesDaily,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/debt-tree/view",
    name: "Árvore view",
    component: ViewTree,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/debt-tree/approach-flow",
    name: "Fluxos de abordagem",
    component: ApproachFlow,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/debt-tree/approach-flow/:approach_id",
    name: "Fluxo de abordagem",
    component: ApproachFlowForm,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/initiatives",
    name: "Gerenciador de iniciativas",
    component: InitiativeManager,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/senders",
    name: "Senders",
    component: SenderManager,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "/pools",
    name: "Pools de sms",
    component: Pools,
    beforeEnter: checkAuth,
    props: true,
},
{
    path: "*",
    redirect: "/",
},
{
    path: '/not-found',
    name: 'NotFound',
    component: NotFound
},
{
    path: '/error',
    name: 'Error',
    component: Error
},
{
    path: '**',
    redirect: '/not-found'
}
];